import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './AITool.css';

const BACKEND = 'http://localhost:5000';

export default function AITool() {
  const { t, language } = useLanguage();
  const ai = t.aitool;
  const [jobText, setJobText] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const analyze = async () => {
    if (!jobText.trim()) return;
    setLoading(true);
    setResult(null);
    setError('');
    try {
      const res = await fetch(`${BACKEND}/api/analyze-job`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobText, language }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error');
      setResult(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aitool-page">
      <div className="aitool-header">
        <Link to="/" state={{ scrollTo: 'projects' }} className="back-link">
          {ai.back}
        </Link>
        <span className="aitool-badge">AI-Powered</span>
      </div>

      <section className="aitool-hero">
        <h1>{ai.title}</h1>
        <p>{ai.subtitle}</p>
      </section>

      <section className="aitool-main">
        <div className="aitool-input-card">
          <label className="aitool-label">{ai.inputLabel}</label>
          <textarea
            className="aitool-textarea"
            placeholder={ai.placeholder}
            value={jobText}
            onChange={e => setJobText(e.target.value)}
            rows={12}
          />
          <button
            className="aitool-btn"
            onClick={analyze}
            disabled={loading || jobText.trim().length < 50}
          >
            {loading ? ai.analyzing : ai.analyzeBtn}
          </button>
        </div>

        {error && <p className="aitool-error">{error}</p>}

        {result && (
          <div className="aitool-results">
            <div className="aitool-card aitool-card--overview">
              <h3>{ai.roleOverview}</h3>
              <p>{result.roleOverview}</p>
            </div>

            <div className="aitool-grid">
              <div className="aitool-card">
                <h3>{ai.requiredSkills}</h3>
                <ul>
                  {result.requiredSkills?.map((s, i) => <li key={i}>{s}</li>)}
                </ul>
              </div>
              <div className="aitool-card">
                <h3>{ai.niceToHave}</h3>
                <ul>
                  {result.niceToHaveSkills?.map((s, i) => <li key={i}>{s}</li>)}
                </ul>
              </div>
            </div>

            <div className="aitool-card">
              <h3>{ai.responsibilities}</h3>
              <ul>
                {result.keyResponsibilities?.map((r, i) => <li key={i}>{r}</li>)}
              </ul>
            </div>

            <div className="aitool-card aitool-card--tips">
              <h3>{ai.positioningTips}</h3>
              <ul>
                {result.positioningTips?.map((tip, i) => <li key={i}>{tip}</li>)}
              </ul>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
